import script from "./Chapter.vue?vue&type=script&setup=true&lang=js"
export * from "./Chapter.vue?vue&type=script&setup=true&lang=js"

import "./Chapter.vue?vue&type=style&index=0&id=6ea971ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ea971ea"]])

export default __exports__